import CityviewLogo from '@afinius/theme/logos/cityview/black.svg?component';
import CityviewGrayLogo from '@afinius/theme/logos/cityview/gray.svg?component';
import NodrGrayLogo from '@afinius/theme/logos/nodr/gray.svg?component';
import NodrLogo from '@afinius/theme/logos/nodr/nodr.svg?component';
import { computed, FunctionalComponent } from 'vue';

export interface AppInfo {
  logo: FunctionalComponent;
  logoGray: FunctionalComponent;
  logoMaxWidth: string;
  name: string;
}

export function useAppInfo() {
  const appParam = new URLSearchParams(location.search).get('app');

  return computed<AppInfo | null>(() => {
    switch (appParam) {
      case 'cityview':
        return {
          logo: CityviewLogo,
          logoGray: CityviewGrayLogo,
          logoMaxWidth: '80%',
          name: 'Cityview',
        };
      case 'nodr':
        return {
          logo: NodrLogo,
          logoGray: NodrGrayLogo,
          logoMaxWidth: 'none',
          name: 'MijnNODR',
        };
      default:
        return null;
    }
  });
}
